export default __webpack_public_path__ + "../images/preloader-blue.svg";